import { render, staticRenderFns } from "./createDonasi.vue?vue&type=template&id=474d23e3&"
import script from "./createDonasi.vue?vue&type=script&lang=js&"
export * from "./createDonasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports